import dayjs from 'dayjs'
import { IPlaningTransfer } from '@/interface/IPlanningProviderResponse'

export const ValidateSearch = (jsonData: any) => {
    if (jsonData.projectId === "") {
        return { 
            msg: `กรุณาเลือก โครงการ`,
            status: false
        }
    }

    if (jsonData.unitSelectType === "unitRange") {
        if (jsonData.unitFrom === "" || jsonData.unitTo === "") {
            return { 
                msg: `ประเภทการค้นหายูนิต เป็น ช่วงยูนิต กรุณากรอกข้อมูลให้ถูกต้อง`,
                status: false
            }
        }
    }

    if (jsonData.unitSelectType === "unitSelected") {
        if (jsonData.unitSelected.length === 0) {
            return { 
                msg: `ประเภทการค้นหายูนิต เป็น ระบุยูนิต ต้องเลือก ยูนิต อย่างน้อย 1 รายการ`,
                status: false
            }
        }
    }
    return { 
        msg: ``,
        status: true
    }
}

export const ValidateTransferSave = (selected: any, productId: number) => {
    console.log('ValidateTransferSave 1', selected)
    let unitCodeNotBooking = selected.filter((x: IPlaningTransfer) => x.bookingId === 0)
    if (unitCodeNotBooking.length > 0) {
        return { 
            msg: `Unit ต่อไปนี้ ยังไม่ได้ทำการจอง : ${unitCodeNotBooking.map((x: IPlaningTransfer) => x.unitCode).join()}`,
            status: false
        }
    }

    let masterTimeData = [
        {name : '09:00'},{name : '09:15'},{name : '09:30'},{name : '09:45'},
        {name : '10:00'},{name : '10:15'},{name : '10:30'},{name : '10:45'},
        {name : '11:00'},{name : '11:15'},{name : '11:30'},{name : '11:45'},
        {name : '12:00'},{name : '12:15'},{name : '12:30'},{name : '12:45'},
        {name : '13:00'},{name : '13:15'},{name : '13:30'},{name : '13:45'},
        {name : '14:00'},{name : '14:15'},{name : '14:30'},{name : '14:45'},
        {name : '15:00'},{name : '15:15'},{name : '15:30'},{name : '15:45'},
        {name : '16:00'},{name : '16:15'},{name : '16:30'},{name : '16:45'},
        {name : '17:00'},{name : '17:15'},{name : '17:30'},{name : '17:45'},
        {name : '18:00'}
    ]

    const ls1PlanCRTime = selected.filter((x: IPlaningTransfer) => x.inspection1PlanCRTime != '' )
    for (let j = 0; j < ls1PlanCRTime.length; j++) {
        const value = ls1PlanCRTime[j].inspection1PlanCRTime

        let objTime =  masterTimeData.filter((timeNew) => timeNew.name == value)
        if (objTime.length == 0)
        {
            console.log("objTime.data :", "เข้า")
            return { 
                msg: `ข้อมูลเวลาที่นัดลูกค้าตรวจ 1 ไม่ถูกต้อง`,
                status: false
            }
        }
    }

    const lsTimeLatest = selected.filter((x: IPlaningTransfer) => x.inspectionPlanCRTimeLatest != '' )
    for (let i = 0; i < lsTimeLatest.length; i++) {
        let value = lsTimeLatest[i].inspectionPlanCRTimeLatest
        // console.log("value :",value)

        let objTime =  masterTimeData.filter((timeNew) => timeNew.name == value)
        if (objTime.length == 0)
        {
            return { 
                msg: `ข้อมูลเวลาที่นัดลูกค้าตรวจล่าสุด ไม่ถูกต้อง`,
                status: false
            }
        }
    }

    // let condoProductId = 2
    // if (productId != condoProductId) {
    //     let unitCodeNotSign = selected.filter((x: IPlaningTransfer) => x.signId === 0)
    //     if (unitCodeNotSign.length > 0) {
    //         return { 
    //             msg: `Unit ต่อไปนี้ ยังไม่ได้ทำการเปิดสัญญา : ${unitCodeNotSign.map((x: IPlaningTransfer) => x.unitCode).join()}`,
    //             status: false
    //         }
    //     }
    // } 

    let unitCodeNotSelectedCrId = selected.filter((x: IPlaningTransfer) => x.crId === 0)
    if (unitCodeNotSelectedCrId.length > 0) {
        return { 
            msg: `Unit ต่อไปนี้ ยังไม่ระบุ CR Name : ${unitCodeNotSelectedCrId.map((x: IPlaningTransfer) => x.unitCode).join()}`,
            status: false
        }
    }

    let unitCodeCheckCrPlan = selected.filter((x: IPlaningTransfer) => x.crPlan === "")
    if (unitCodeCheckCrPlan.length > 0) {
        return { 
            msg: `Unit ต่อไปนี้ ยังไม่ระบุ CR Plan เพื่อทำรายการโอน Unit : ${unitCodeCheckCrPlan.map((x: IPlaningTransfer) => x.unitCode).join()}`,
            status: false
        }
    }

    let unitCodeCheckBankId = selected.filter((x: IPlaningTransfer) => x.bankId == "0" && x.transferTypeId == 42)
    if (unitCodeCheckBankId.length > 0) {
        return { 
            msg: `Unit ต่อไปนี้ถ้าเลือก ประเภทการโอน เป็น สินเชื่อ ต้องระบุธนาคารที่เลือกใช้ก่อน : ${unitCodeCheckBankId.map((x: IPlaningTransfer) => x.unitCode).join()}`,
            status: false
        }
    }

    return {
        msg: ``,
        status: true
    }
}

export const ValidateTransferSaveSendEmail = (selected: any, jsonData: any) => {
    console.log('ValidateTransferSaveSendEmail', selected, jsonData.productType)
    if (jsonData.emailType === 0 ) {
        return { 
            msg: `กรุณาเลือกประเภทอีเมล`,
            status: false
        }
    }

    let unitCodeCheckSAPContractNo = selected.filter((x: IPlaningTransfer) => x.sapContractNo.trim() === "")
    if (unitCodeCheckSAPContractNo.length > 0) {
        return { 
            msg: `Unit ต่อไปนี้ ต้องเปิด SAP ก่อน : ${unitCodeCheckSAPContractNo.map((x: IPlaningTransfer) => x.unitCode).join()}`,
            status: false
        }
    }

    if (jsonData.productType != 2) {
        let unitCodeCheckFlagHaveAddress = selected.filter((x: IPlaningTransfer) => x.flagHaveAddress !== "Y")
        if (unitCodeCheckFlagHaveAddress.length > 0) {
            return { 
                msg: `Unit ต่อไปนี้ กรุณาให้ GA ยืนยันทะเบียนบ้านก่อนส่งอีเมลของ : ${unitCodeCheckFlagHaveAddress.map((x: IPlaningTransfer) => x.unitCode).join()}`,
                status: false
            }
        }
    }

    let unitCodeCheckBankId = selected.filter((x: IPlaningTransfer) => x.bankId == "0" && x.transferTypeId == 42)
    if (unitCodeCheckBankId.length > 0) {
        return { 
            msg: `Unit ต่อไปนี้ถ้าเลือก ประเภทการโอน เป็น สินเชื่อ ต้องระบุธนาคารที่เลือกใช้ก่อน : ${unitCodeCheckBankId.map((x: IPlaningTransfer) => x.unitCode).join()}`,
            status: false
        }
    }

    let error = {  msg: ``, status: true }
    selected.forEach((x: IPlaningTransfer) => {

        if (x.transferTypeId !== 40 || x.flagActiveTransfer === false) {
            // โอนปกติ
            if (jsonData.emailType === 442) {
                
                if (x.flagTransferLetterBefore === true) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ มีการส่งนัดโอนแล้ว กรุณาทำรายการยกเลิกนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลนัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDate.trim() === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาระบุวันที่นัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }
            }

            // อีเมลเปลี่ยนแปลงข้อมูลโอน
            if (jsonData.emailType === 443) {
                if (x.flagTransferLetterBefore === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลเปลี่ยนแปลงข้อมูลโอน ต้องส่งอีเมลนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferChangeLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลเปลี่ยนแปลงข้อมูลโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDate !== x.transferPlanDateBefore) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลแปลี่ยนแปลงข้อมูลโอน ห้ามเปลี่ยนแปลงวันที่นัดโอน กรุณาใช้วันเดิม ${x.transferPlanDateBefore} (Unit : ${x.unitCode})`,
                        status: false
                    }
                }
                if (x.lettTransRemark.trim() === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลแปลี่ยนแปลงข้อมูลโอน กรุณาใส่ หมายเหตุ(อัพเดทอีเมลแจ้งโอน) : ${x.unitCode}`,
                        status: false
                    }
                }
            }

            // อีเมลนัดโอน
            if (jsonData.emailType === 442) {
                if (x.flagTransferLetterBefore === true) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ มีการส่งนัดโอนแล้ว กรุณาทำรายการยกเลิกนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลนัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDate.trim() === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาระบุวันที่นัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }
            }

            // อีเมลเปลี่ยนแปลงข้อมูลโอน
            if (jsonData.emailType === 443) {
                if (x.flagTransferLetterBefore === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลเปลี่ยนแปลงข้อมูลโอน ต้องส่งอีเมลนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferChangeLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลเปลี่ยนแปลงข้อมูลโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDate !== x.transferPlanDateBefore) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลแปลี่ยนแปลงข้อมูลโอน ห้ามเปลี่ยนแปลงวันที่นัดโอน กรุณาใช้วันเดิม ${x.transferPlanDateBefore} (Unit : ${x.unitCode})`,
                        status: false
                    }
                }
                if (x.lettTransRemark.trim() === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลแปลี่ยนแปลงข้อมูลโอน กรุณาใส่ หมายเหตุ(อัพเดทอีเมลแจ้งโอน) : ${x.unitCode}`,
                        status: false
                    }
                }
            }

            // อีเมลยกเลิกโอน
            if (jsonData.emailType === 444) {
                if (x.flagTransferLetterBefore === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลยกเลิกโอน ต้องส่งอีเมลนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferCancelLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลยกเลิกโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDate !== x.transferPlanDateBefore) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลยกเลิกโอน ห้ามเปลี่ยนแปลงวันที่นัดโอน กรุณาใช้วันเดิม ${x.transferPlanDateBefore} (Unit : ${x.unitCode})`,
                        status: false
                    }
                }
                if (x.lettTransRemark.trim() === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลยกเลิกโอน กรุณาใส่ หมายเหตุ(อัพเดทอีเมลแจ้งโอน) : ${x.unitCode}`,
                        status: false
                    }
                }
            }

            // อีเมลผิดนัดโอน
            if (jsonData.emailType === 445) {
                if (x.flagTransferOutLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลผิดนัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferOutDateHistory.trim() === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลผิดนัดโอน กรุณากรอกวันที่ผิดนัดโอนกรรมสิทธิ์ : ${x.unitCode}`,
                        status: false
                    }
                }
            }

            // อีเมลเลื่อนวันโอน
            if (jsonData.emailType === 509) {
                if (x.flagTransferLetterBefore === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลเลื่อนวันโอน ต้องส่งอีเมลนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferAdjustLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลเลื่อนวันโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDate === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาระบุวันที่นัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDate !== "") {
                    const date1 = dayjs(`${dayjs(x.transferPlanDate).format('YYYY-MM-DD')}`)
                    const date2 = dayjs()
                    const date = date1.diff(date2, 'minute')
                    if (date <= 0) {
                        error =  { 
                            msg: `Unit ต่อไปนี้ วันที่นัดโอน ห้ามใส่น้อยกว่าวันปัจจุบัน : ${x.unitCode}`,
                            status: false
                        }
                    }
                }
            }

            // อีเมลยกเลิกผิดนัดโอน
            if (jsonData.emailType === 756) {
                if (x.flagTransferOutLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมล ยกเลิกผิดนัดโอน ต้องมีการส่งอีเมลผิดนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferOutCancelLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมล ยกเลิกผิดนัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }
            }

        } else {
            // โอนลอย
            console.log('--> ValidateTransferSaveSendEmail โอนลอย 1', jsonData.emailType)
            // อีเมลนัดโอน
            if (jsonData.emailType === 442) {
                if (x.flagTransferLetterBefore === true) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ มีการส่งนัดโอนแล้ว กรุณาทำรายการยกเลิกนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลนัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }    
                if (x.transferPlanDateSp.trim() === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาระบุวันที่นัดโอนหลังโอนลอย : ${x.unitCode}`,
                        status: false
                    }
                }
            }

            // อีเมลเปลี่ยนแปลงข้อมูลโอน
            if (jsonData.emailType === 443) {
                if (x.flagTransferLetterBefore === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลเปลี่ยนแปลงข้อมูลโอน ต้องส่งอีเมลนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferChangeLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลเปลี่ยนแปลงข้อมูลโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDateSpBefore !== x.transferPlanDateSp) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลแปลี่ยนแปลงข้อมูลโอน ห้ามเปลี่ยนแปลงวันที่นัดโอนหลังโอนลอย กรุณาใช้วันเดิม ${x.transferPlanDateBefore} (Unit : ${x.unitCode})`,
                        status: false
                    }
                }
                if (x.lettTransRemark.trim() === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลแปลี่ยนแปลงข้อมูลโอน กรุณาใส่ หมายเหตุ(อัพเดทอีเมลแจ้งโอน) : ${x.unitCode}`,
                        status: false
                    }
                }
            }

            // อีเมลยกเลิกโอน
            if (jsonData.emailType === 444) {
                if (x.flagTransferLetterBefore === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลยกเลิกโอน ต้องส่งอีเมลนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferCancelLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลยกเลิกโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDateSpBefore !== x.transferPlanDateSp) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลยกเลิกโอน ห้ามเปลี่ยนแปลงวันที่นัดโอนหลังโอน กรุณาใช้วันเดิม ${x.transferPlanDateBefore} (Unit : ${x.unitCode})`,
                        status: false
                    }
                }
                if (x.lettTransRemark.trim() === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลยกเลิกโอน กรุณาใส่ หมายเหตุ(อัพเดทอีเมลแจ้งโอน) : ${x.unitCode}`,
                        status: false
                    }
                } 
            }   
            
            // อีเมลผิดนัดโอน
            if (jsonData.emailType === 445) {
                if (x.flagTransferOutLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลผิดนัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferOutDateHistory.trim() === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลผิดนัดโอน กรุณากรอกวันที่ผิดนัดโอนกรรมสิทธิ์ : ${x.unitCode}`,
                        status: false
                    }
                }
            }

            // อีเมลเลื่อนวันโอน
            if (jsonData.emailType === 509) {
                if (x.flagTransferLetterBefore === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมลเลื่อนวันโอน ต้องส่งอีเมลนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.flagTransferAdjustLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมลเลื่อนวันโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDate === "") {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาระบุวันที่นัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }
                if (x.transferPlanDateSp !== "") {
                    const date1 = dayjs(`${dayjs(x.transferPlanDateSp).format('YYYY-MM-DD')}`)
                    const date2 = dayjs()
                    const date = date1.diff(date2, 'minute')
                    if (date <= 0) {
                        error =  { 
                            msg: `Unit ต่อไปนี้ วันที่นัดโอนหลังโอนลอย ห้ามใส่น้อยกว่าวันปัจจุบัน : ${x.unitCode}`,
                            status: false
                        }
                    }
                }
            }

            // อีเมลยกเลิกผิดนัดโอน
            if (jsonData.emailType === 756) {
                if (x.flagTransferOutLetter === false)  {
                    error =  { 
                        msg: `Unit ต่อไปนี้ การส่งอีเมล ยกเลิกผิดนัดโอน ต้องมีการส่งอีเมลผิดนัดโอนก่อน : ${x.unitCode}`,
                        status: false
                    }
                }
                
                if (x.flagTransferOutCancelLetter === false) {
                    error =  { 
                        msg: `Unit ต่อไปนี้ กรุณาติ๊ก checkbox เพื่อส่งอีเมล ยกเลิกผิดนัดโอน : ${x.unitCode}`,
                        status: false
                    }
                }
            }

        }

    })
    return error
}


export const ValidateTransferSaveForPJ = (selected: any) => {
    
    let masterTimeData = [
        {name : '09:00'},{name : '09:15'},{name : '09:30'},{name : '09:45'},
        {name : '10:00'},{name : '10:15'},{name : '10:30'},{name : '10:45'},
        {name : '11:00'},{name : '11:15'},{name : '11:30'},{name : '11:45'},
        {name : '12:00'},{name : '12:15'},{name : '12:30'},{name : '12:45'},
        {name : '13:00'},{name : '13:15'},{name : '13:30'},{name : '13:45'},
        {name : '14:00'},{name : '14:15'},{name : '14:30'},{name : '14:45'},
        {name : '15:00'},{name : '15:15'},{name : '15:30'},{name : '15:45'},
        {name : '16:00'},{name : '16:15'},{name : '16:30'},{name : '16:45'},
        {name : '17:00'},{name : '17:15'},{name : '17:30'},{name : '17:45'},
        {name : '18:00'}
    ]

    let ls1PlanCRTime = selected.filter((x: IPlaningTransfer) => x.inspection1PlanCRTime != '' )
    for (let i = 0; i < ls1PlanCRTime.length; i++) {
        let value = ls1PlanCRTime[i].inspection1PlanCRTime
        console.log("value :",value)

        let objTime =  masterTimeData.filter((timeNew) => timeNew.name == value)
        if (objTime.length == 0)
        {
            console.log("objTime.data :", "เข้า")
            return { 
                msg: `ข้อมูลเวลาที่ CR นัดได้#1 ไม่ถูกต้อง`,
                status: false
            }
        }
    }

    let ls2PlanCRTime = selected.filter((x: IPlaningTransfer) => x.inspection2PlanCRTime != '' )
    for (let i = 0; i < ls2PlanCRTime.length; i++) {
        let value = ls2PlanCRTime[i].inspection2PlanCRTime
        console.log("value :",value)

        let objTime =  masterTimeData.filter((timeNew) => timeNew.name == value)
        if (objTime.length == 0)
        {
            console.log("objTime.data :", "เข้า")
            return { 
                msg: `ข้อมูลเวลาที่ CR นัดได้#2 ไม่ถูกต้อง`,
                status: false
            }
        }
    }

    let ls3PlanCRTime = selected.filter((x: IPlaningTransfer) => x.inspection3PlanCRTime != '' )
    for (let i = 0; i < ls3PlanCRTime.length; i++) {
        let value = ls3PlanCRTime[i].inspection3PlanCRTime
        console.log("value :",value)

        let objTime =  masterTimeData.filter((timeNew) => timeNew.name == value)
        if (objTime.length == 0)
        {
            console.log("objTime.data :", "เข้า")
            return { 
                msg: `ข้อมูลเวลาที่ CR นัดได้#3 ไม่ถูกต้อง`,
                status: false
            }
        }
    }

    let ls4PlanCRTime = selected.filter((x: IPlaningTransfer) => x.inspection4PlanCRTime != '' )
    for (let i = 0; i < ls4PlanCRTime.length; i++) {
        let value = ls4PlanCRTime[i].inspection4PlanCRTime
        console.log("value :",value)

        let objTime =  masterTimeData.filter((timeNew) => timeNew.name == value)
        if (objTime.length == 0)
        {
            console.log("objTime.data :", "เข้า")
            return { 
                msg: `ข้อมูลเวลาที่ CR นัดได้#4 ไม่ถูกต้อง`,
                status: false
            }
        }
    }
    
    return {
        msg: ``,
        status: true
    }
}